export default {
	property: 0,
	builder: 0,
	lot_type: 0,
	prospect_count: null,
	realtor_count: null,
	traffic_date: 0,
	subdivision: null,
	neighborhood:null,
	section_id: null
}